import React from "react";
import {
  ActivityIndicator,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import color from "@constants/color";
import TickCircle from "@assets/svg/ShopPerformance/TickCircle";
import ButtonError from "@assets/svg/WithdrawGullakMoney/ButtonError";
import { ScaledSheet } from '@utils/scale';
import { AddFundBtnStatusTypes } from "../utils";

const AddFundButton = ({ onPress = () => {}, type, disabled, text }) => {
  const renderButtonPrefix = () => {
    switch (type) {
      case AddFundBtnStatusTypes.SUCCESS:
        return <TickCircle width={18} height={18} />;
      case AddFundBtnStatusTypes.ERROR:
        return <ButtonError width={18} height={18} />;
      case AddFundBtnStatusTypes.LOADING:
        return (
          <ActivityIndicator size="small" color={color.mediumBlacklightBlack} />
        );
      default:
        return null;
    }
  };
  return (
    <TouchableOpacity
      testID="wgm-add-fund-button"
      onPress={onPress}
      disabled={disabled}
      style={[
        styles.buttonStyle,
        type === AddFundBtnStatusTypes.SUCCESS
          ? {
              backgroundColor: "rgba(39, 174, 96, 0.1)",
            }
          : type === AddFundBtnStatusTypes.ERROR
            ? { backgroundColor: "rgba(255, 46, 0, 0.2)" }
            : type === AddFundBtnStatusTypes.LOADING
              ? { backgroundColor: color.white }
              : null,
      ]}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View style={{ marginLeft: -20, marginRight: 10 }}>
          {renderButtonPrefix()}
        </View>
        <Text
          style={[
            styles.buttonText,
            type === AddFundBtnStatusTypes.SUCCESS
              ? { color: color.plain_green }
              : type === AddFundBtnStatusTypes.ERROR
                ? { color: color.plain_red }
                : type === AddFundBtnStatusTypes.LOADING
                  ? { color: color.mediumBlacklightBlack }
                  : null,
          ]}
        >
          {text}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default AddFundButton;

const styles = ScaledSheet.create({
  buttonStyle: {
    height: 40,
    width: "100%",
    backgroundColor: "#2F80ED",
    borderRadius: 6,
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "700",
  },
});
